export const REQUIRED_FIELD = "Campo obrigatório não preenchido";
export const BIGGER_FIELD =
  "O valor superior deve ser menor ou igual ao valor inferior";
export const INVALID_EMAIL = "Email inválido";
export const EMAIL_EXISTS = "O Email já está em uso";
export const NO_RESULTS = "Sem resultados";
export const ERROR_API_CALL =
  "Por favor, contacte o administrador da fonte externa ou tente novamente mais tarde.";
export const ERROR_FINDING_RESULTS =
  "Não foi possível ligar ao servidor. Por favor, tente novamente mais tarde.";
export const DELETE_DIALOG_MESSAGE =
  "Tem a certeza que pretende eliminar este item?";
export const CANCEL_DIALOG_MESSAGE =
  "Tem a certeza que deseja sair sem criar? As alterações não serão guardadas e perderá todo o progresso.";
export const ROLE_SUMMARY =
  "Nesta página é possível adicionar, editar e visualizar todos os perfis";
export const USER_SUMMARY =
  "Nesta página é possível adicionar, editar e visualizar todos os utilizadores";
export const AUXILIAR_SUMMARY =
  "Nesta página é possível gerir tabelas auxiliares";
export const ORGANIZATION_SUMMARY =
  "Nesta página é possível adicionar, editar e visualizar todos as entidades";
export const INDICATOR_MANAGEMENT_SUMMARY =
  "Nesta página é possível visualizar e gerir todos os indicadores";
export const AUDIT_SUMMARY =
  "Nesta página é possível auditar as acções realizadas no sistema";
export const MY_USER_SUMMARY =
  "Nesta página é possível editar e visualizar os Utilizadores da minha Escola";
export const INDICATOR_SUMMARY =
  "Nesta página é possível analisar um indicador em várias regiões ou todos os indicadores de uma região.";
export const INDICATOR_REGION_ANALYSIS_SUMMARY =
  "Veja todos os indicadores de uma determinada região";
export const INDICATOR_ANALYSIS_SUMMARY =
  "Compare os valores de um mesmo indicador em diferentes regiões";
export const BULLETIN_SUMMARY =
  "Nesta página é possível visualizar todos os boletins";
export const DOCUMENTS_SUMMARY =
  "Nesta página é possível criar, editar e visualizar documentos";
export const FIELD_OCCURENCES_SUMMARY =
  "Nesta página é possível visualizar as ocorrências no terreno";
export const NO_OPTIONS_MESSAGE = () => "Sem resultados";
export const PUBLIC_NATURES = "Pública";
export const PRIVATE_NATURES = "Privada";
export const PRIVATE_OR_PUBLIC_NATURES = "Público-Privada";
export const regexPattern = /^\d{9}[A-Z]{2}\d{3}$/;
export const PAGE_SIZE = 10;
export const EDIT_ALERT_COMPONENT_TITLE =
  "Por favor, reveja os dados inseridos em baixo";
export const EDIT_ALERT_COMPONENT_DESCRIPTION =
  "Caso pretenda alterar os dados inseridos, por favor clique em recuar";

export const handleEnterOnSearch = (event: any, onSubmit: any) => {
  if (event.key === "Enter") {
    onSubmit();
  }
};

export const TYPEDOCUMENTBI = "Bilhete de Identidade";
export const ARCHIVED = "Arquivado";
export const BULLETIN_DATE = 0;
export const PAGE_SIZE_OPTIONS: number[] = [10, 20, 30];

export const MONTH_NAMES = [
  "Janeiro",
  "Fevereiro",
  "Março",
  "Abril",
  "Maio",
  "Junho",
  "Julho",
  "Agosto",
  "Setembro",
  "Outubro",
  "Novembro",
  "Dezembro",
];

export const TRIMESTRAL_NAMES = [
  "1º Trimestre",
  "2º Trimestre",
  "3º Trimestre",
  "4º Trimestre",
];

export const SEMESTRAL_NAMES = ["1º Semestre", "2º Semestre"];
